export const environment = {
	production: true,
	api: '', // provided via env vars
	web: '', // provided via env vars
	accessToken: '2229a40a7294488db336d13f98c5cba9',
	supportUrl: 'https://www.racoman.com/support/alarmagent',
};
